import { render, staticRenderFns } from "./EmployeeDetailsCardWagesDialog.vue?vue&type=template&id=d5c4e81e&scoped=true&"
import script from "./EmployeeDetailsCardWagesDialog.vue?vue&type=script&lang=ts&"
export * from "./EmployeeDetailsCardWagesDialog.vue?vue&type=script&lang=ts&"
import style0 from "./EmployeeDetailsCardWagesDialog.vue?vue&type=style&index=0&id=d5c4e81e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5c4e81e",
  null
  
)

export default component.exports